<template>
    <div>
        <b-modal v-model="openAgentForm" no-close-on-backdrop no-close-on-esc :size="'xl'">
            <template #modal-header>
                <div class="w-100">
                    <div v-if="agent != null && !agent.isNew" class="card-header w-100 d-flex">
                        <h2 class="mb-0 mr-4">
                            {{ agent.name + (agent.nickname && agent.nickname.trim() != '' ? ' (' + agent.nickname + ')' : '') }}
                        </h2>

                        <div @click="toggleActive()" type="submit" md="3"
                            :class="`button-habilitar ml-4 ${!currentAgentAgentData.mainPlaceAgentData.active.value ? 'bg-success pt-1 pb-1 pr-2 pl-2 text-white' : 'bg-danger pt-1 pb-1 pr-2 pl-2 text-white'}`">
                            {{ currentAgentAgentData.mainPlaceAgentData.active.value ? 'Desabilitar' : 'Habilitar' }}
                        </div>

                        <div>
                            <div class="switch-wrapper">
                                <label class="switch-container mb-0">
                                    <input type="checkbox" class="switch" :checked="isActive" @change="toggleActive()" />
                                    <span class="slider"></span>
                                </label>

                                <span class="status-label">
                                    {{ isActive ? "Desabilitar" : "Habilitar" }}
                                </span>
                            </div>
                            <div v-if="isActive" style="font-weight: 600;" :style="isActive ? 'color: #22a06b;' : 'color: #D93051;'">
                                {{ isActive ? 'O agente está habilitado.' : 'O agente está desabilitado.' }}
                            </div>
                            <!-- <div v-else style="font-weight: 600; color: #D93051;">
                                O agente está desabilitado.
                            </div> -->

                        </div>
                        <div class="ml-auto">
                            <base-button :disabled="!currentAgentAgentData.agent.currentPlaceHasMainAffiliation"
                                @click="confirmRemoveAgentAfilitaion()" type="submit" md="3"
                                :class="`btn text-right ml-auto ${!removeAfiliatedCheckbox ? 'bg-danger pt-1 pb-1 pr-2 pl-2 text-white' : 'bg-gray pt-1 pb-1 pr-2 pl-2 text-white'}`">
                                {{ removeAfiliatedCheckbox ? 'Vincular' : 'Desvincular' }}
                            </base-button>
                        </div>
                    </div>

                    <div v-else class="pt-2 pl-3">
                        <div style="font-size: large; font-weight: 600; color: black;">
                            {{ currentAgentAgentData.agent.name ? 'Validar cadastro: ' + currentAgentAgentData.agent.name : 'Adicionar Agente' }}
                        </div>

                        <div style="color: black;">Digite as informações solicitadas para adicionar um agente.</div>

                        <div class="d-flex mt-2">
                            <div style="color: gray;">
                                Antes de começar, confira quais documentos vão ser necessários para finalizar o formulário:
                                <span @click="openModaldocs" class="open-modal-docs-text pl-2" style="color: #D93051;">
                                    <!-- botão para abrir o modal docs-->
                                    <i class="no no-c-warning pr-1" style="color: #D93051;"></i>
                                    Documentos necessários
                                </span>
                            </div>

                            <div>   <!-- modal docs-->
                                <AgentDocsModal :isDocsModalOpen="isDocsModalOpen" @closeModaldocs="closeModaldocs">
                                </AgentDocsModal>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="text-right">
                    <button @click.prevent="closeAgentModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span @click.prevent="closeAgentModal()">x</span>
                    </button>
                </div>
            </template>

            <AgentForm v-if="openAgentForm" :agent="currentAgentAgentData.agent" :dialCodesArray="dialCodesArray"
                :mainPlaceAgentData="currentAgentAgentData.mainPlaceAgentData" :agentTmpFiles="agentTmpFiles"
                :agentUploadImage="agentUploadImage" :agentTmpImage="agentTmpImage"
                :enabledFormFields="enabledFormFields" :pages="pages" :pageControl="pageControl"
                :currentPage="currentPage" :isBackable="isBackable" :isNextable="isNextable"
                :removeAfiliatedCheckbox="removeAfiliatedCheckbox" @agentUpdated="emitUpdateAgentRow"
                @emitRemoveAfiliatedCheckbox="emitRemoveAfiliatedCheckbox" @emitFormWaiting="emitFormWaiting"
                @emitBlockEdit="emitBlockEdit" @emitFormErrors="emitFormErrors" @emitAgentTmpFiles="emitAgentTmpFiles"
                @emitAgentTmpImage="emitAgentTmpImage" @emitAgentUploadImage="emitAgentUploadImage">
            </AgentForm>

            <template #modal-footer>
                <div class="w-100">
                    <div class="progress-bar mb-2">
                        <div class="progress-bar-inside" :style="{ width: progressPercentage }"></div>
                    </div>

                    <div class="modal-add-footer">
                        <div class="d-flex w-100">
                            <div @click.prevent="previousPage()" :disabled="!isBackable" class="btn btn-outline-danger w-100" style="padding-top: 9px;">VOLTAR</div>
                            <div @click.prevent="nextPage()" :disabled="!isNextable" class="btn btn-back w-100" style="padding-top: 9px;">AVANÇAR</div>

                            <div v-if="!blockEdit" class="text-right w-100">
                                <div :disabled="formWaiting" @click.prevent="saveAgentForm()"
                                    :type="removeAfiliatedCheckbox ? 'danger' : 'next'" class="btn btn-next"
                                    style="padding-top:10px; padding-bottom: 10px; width: 100%">
                                    {{ confirmButtonLabel }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import AgentForm from './AgentForm.vue'
import AgentDocsModal from './AgentDocsModal.vue';
import { hasModule } from '../../store/utils/users'
import { mapActions, mapGetters } from 'vuex';
import swal from "sweetalert2"
import "sweetalert2/dist/sweetalert2.css"
import cakeService from '@/services/cakephp'
import bocapioService from "@/services/nodejs/index"

export default {
    name: 'AgentModal',

    components:{
        AgentForm,
        AgentDocsModal,
    },

    props:{
        openAgentForm: {
            type: Boolean,
            default: false
        },

        agent: {
            type: Object,
            default: {},
        },

        currentAgentAgentData: {
            type: Object,
            default: {},
        },

    },

    data() {
        return {
            confirmButtonLabel: 'SALVAR',
            formWaiting: false, blockEdit: false, removeAfiliatedCheckbox: false, formErrors: false,
            isDocsModalOpen: false,
            pages: { pagecontrol_1: ['base_buttons_session','user_data_session','page_1'], zLast: ['formation_data_session','afilitaion_data_session'] },
            pageControl: 'pagecontrol_1',
            agentTmpFiles: {},
            agentUploadImage: null, agentTmpImage: null,
            handle_city_agents: false, handle_my_place_agents: false,
        }
    },

    computed: {
        ...mapGetters('booking', {
            dialCodesArray: 'getDialCodesArray',
        }),

        isActive(){ return this.currentAgentAgentData.mainPlaceAgentData.active.value },

        enabledFormFields(){
            let xFormFields = {}
            let currentSessionClass = 'page_1'

            Object.values(this.currentAgentAgentData.mainPlaceAgentData).map(field => {
                if(field.label && field.label.indexOf('page_') === 0 && field.type != 'disabled'){
                    currentSessionClass = field.label.toString()
                    this.pages['pagecontrol_'+Object.keys(this.pages).length] = [currentSessionClass]
                }
                if(!xFormFields[currentSessionClass]){ xFormFields[currentSessionClass] = [] }
                if(field.type != 'disabled'){ xFormFields[currentSessionClass].push(field) }
            })

            return Object.entries(xFormFields)
        },

        currentPage(){ return this.pages[this.pageControl] },

        isBackable(){
            const pagesKeys = Object.keys(this.pages).sort();
            return pagesKeys.indexOf(this.pageControl) > 0
        },

        isNextable(){
            const pagesKeys = Object.keys(this.pages).sort();
            return (pagesKeys.indexOf(this.pageControl) < pagesKeys.length - 1) && (!this.formErrors)
        },

        progressPercentage(){
            const pagesKeys = Object.keys(this.pages).sort();
            const pagesNumber = pagesKeys.length;
            let currentPageIndex = pagesKeys.indexOf(this.pageControl) + 1;
            let percentage = currentPageIndex == 0 ? 0 : ((currentPageIndex/pagesNumber) * 100).toFixed(2)
            return `${percentage}%`
        },
    },

    watch: {

    },

    methods: {
        ...mapActions('booking', [
            'fetchDialCodes',
        ]),

        toggleActive() {
            this.currentAgentAgentData.mainPlaceAgentData.active.value = !this.currentAgentAgentData.mainPlaceAgentData.active.value
            if (this.currentAgentAgentData.mainPlaceAgentData.active) {
            }
        },

        closeAgentModal(){ this.$emit("closeAgentModal", false)  },

        openModaldocs(){ this.isDocsModalOpen = true },

        closeModaldocs(){ this.isDocsModalOpen = false },

        emitUpdateAgentRow(event){ this.$emit("emitUpdateAgentRow", event) },

        emitFormWaiting(value){ this.formWaiting = value },

        emitBlockEdit(value){ this.blockEdit = value },

        emitFormErrors(value){ this.formErrors = value },

        emitRemoveAfiliatedCheckbox(value){ this.removeAfiliatedCheckbox = value },

        emitAgentTmpFiles(value){ this.agentTmpFiles = {...this.agentTmpFiles,...value} },

        emitAgentTmpImage(value){ this.agentTmpImage = value },

        emitAgentUploadImage(value){ this.agentUploadImage = value },

        previousPage(){
            if(this.isBackable){
                const pagesKeys = Object.keys(this.pages).sort();
                let currentPageIndex = pagesKeys.indexOf(this.pageControl);

                if (currentPageIndex > 0) {
                    this.pageControl = pagesKeys[--currentPageIndex];
                }
            }
        },

        nextPage(){
            const invalidFields = document.querySelectorAll("[required]:not([valid='true'])");

            if (invalidFields.length > 0) {
                this.formErrors = true;

                setTimeout(() => {
                    invalidFields[0].focus();
                    invalidFields[0].blur();
                }, 0);

                this.formWaiting = false;
                return false;
            }

            this.formErrors = false

            if(this.isNextable){
                const pagesKeys = Object.keys(this.pages).sort();
                const pagesNumber = pagesKeys.length;
                let currentPageIndex = pagesKeys.indexOf(this.pageControl);

                if (currentPageIndex >= 0 && currentPageIndex < pagesNumber - 1) {
                    this.pageControl = pagesKeys[++currentPageIndex];
                }
            }
        },

        confirmRemoveAgentAfilitaion() {
          swal.fire({
            text: "Não será possível editar esse cadastro após ser desvinculado!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Desvincular',
            confirmButtonClass: 'btn btn-warning',
            confirmButtonColor: '#DD6B55',
            cancelButtonText: 'Voltar',
            reverseButtons: true,
            cancelButtonColor: 'primary',
            type: 'danger'
          })
          .then((result) => {
            if (result.isConfirmed) {

              this.removeAfiliatedCheckbox = true
              this.blockEdit = true
              this.currentAgentAgentData.mainPlaceAgentData.active.value = false
              this.saveAgent()
            }
            else {
              this.blockEdit = false
              this.removeAfiliatedCheckbox = false
            }
          })
        },

        async saveAgentForm() {
            if (Object.keys(this.agentTmpFiles).length > 0) {
                for (const slug of Object.keys(this.agentTmpFiles)) {
                    await this.saveAgentFile(slug, this.agentTmpFiles[slug]['public_label'], this.agentTmpFiles[slug]['file'])
                }
            }
            await this.saveAgentImage()
            await this.saveAgent()
        },

        async 'saveAgentFile'(slug, public_label, file) {
            this.formWaiting = true
            const formData = new FormData()

            if (file != null && file.size > 0) {
                formData.append("file", file)
                const fileInfo = {
                    name: public_label,
                    refId: this.currentAgentAgentData.uuid || 0,
                    ref: 'agent',
                    status: 1,
                }

                await bocapioService.postDocumento(fileInfo, formData)
                    .then(rsp => {
                        this.currentAgentAgentData.mainPlaceAgentData[slug]['value'] = rsp.data.path
                    })
                    .catch(error => {
                        swal.fire({
                            text: "Erro ao enviar arquivo. " + error.statusText,
                            buttonClass: "btn btn-error",
                            icon: 'error'
                        })
                    })
            }
        },

        async saveAgentImage() {
            this.formWaiting = true
            const formData = new FormData()

            if (this.agentUploadImage != null && this.agentUploadImage.size > 0) {
                formData.append("file", this.agentUploadImage)
                const fileInfo = {
                    name: this.currentAgentAgentData.agent.name,
                    refId: 0,
                    ref: 'agent',
                    status: 1,
                }

                await bocapioService.postDocumento(fileInfo, formData)
                .then(rsp => {
                    this.currentAgentAgentData.agent.images = rsp.data.path
                })
                .catch(error => {
                    swal.fire({
                        text: "Erro ao enviar imagem. " + error.statusText,
                        buttonClass: "btn btn-error",
                        icon: 'error'
                    })
                })
            }
        },

        async saveAgent() {
            delete this.currentAgentAgentData.mainPlaceAgentData.changed
            let filteredXfields = Object.values(this.currentAgentAgentData.mainPlaceAgentData)
                .filter(xfield => xfield.type != 'hidden_config' && xfield.type != 'disabled')
                .map((xfield) => {
                    return { type: xfield.type, value: xfield.value, label: xfield.label, public_label: xfield.public_label }
                })

            let agent = { ...this.currentAgentAgentData.agent, xfields: filteredXfields }

            // DESVINCULAR AGENT
            if (agent.place_id == 0) { agent.logicx = 2 }
            if (agent.place_id > 0) { agent.logicx = 0 }
            if (this.removeAfiliatedCheckbox) {
                agent.place_id = 0
                agent.logicx = 2
            }

            const invalidFields = document.querySelectorAll("[required]:not([valid='true'])");

            if (invalidFields.length > 0) {
                this.formErrors = true;

                setTimeout(() => {
                    invalidFields[0].focus();
                    invalidFields[0].blur();
                }, 0);

                this.formWaiting = false;
                return false;
            }

            this.formErrors = false
            const response = await cakeService.saveAgent(agent)
            let cakeResponse = JSON.parse(response)
            cakeResponse.flash = JSON.parse(cakeResponse.flash)

            this.$notify({
                message: cakeResponse.flash.message,
                duration: 5000,
                dangerouslyUseHTMLString: true,
                type: 'success', // 'success' | 'warning' | 'info' | 'error'
                position: 'top-right'//'top-right' | 'top-left' | 'bottom-right' | 'bottom-left'
            })

            if ('success' == cakeResponse.status) {
                this.emitUpdateAgentRow(cakeResponse.Agent)
            }
            else { this.emitUpdateAgentRow(false) }
        },

    },

    async mounted(){
        this.handle_my_place_agents = hasModule('handle_my_place_agents')
        this.handle_city_agents = hasModule('handle_city_agents')

        await this.fetchDialCodes()
    },

}
</script>

<style>
    .modal-add-footer {
        display: flex;
    }

   /* .progress-bar {
        background-color: #D9D9D9;
        width: auto;
        height: 10px;
        border-radius: 10px;
        margin-bottom: 15px;
   } */

   .progress-bar-inside {
        background-color: #A7AA37;
        width: auto;
        height: 10px;
        border-radius: 10px;
   }

   .switch-wrapper {
  display: flex;
  align-items: center;
}

.switch-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
}

.switch {
  width: 40px;
  height: 20px;
  position: relative;
  appearance: none;
  background: #ccc;
  border-radius: 20px;
  outline: none;
  cursor: pointer;
  transition: background 0.3s;
}

.switch:checked {
  background: #22a06b;
}

.switch:before {
  content: "";
  position: absolute;
  width: 18px;
  height: 18px;
  background: white;
  border-radius: 50%;
  top: 1px;
  left: 2px;
  transition: 0.3s;
}

.switch:checked:before {
  left: 20px;
}

.status-label {
  margin-left: 10px;
  font-weight: 600;
  color: #1b1b1b;
}

.button-habilitar {
    display: none;
}

</style>
